// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"2da86edf","453":"54292a4b","455":"7d849559","879":"bc896dd3","977":"4c6b8575"}[chunkId] + ".chunk.js";
};